import { z } from 'zod';
import { CommonProcessPaymentFormSchema } from '../ProcessPaymentFormSchema';

export enum MewsTerminalFormField {
    PaymentTerminalId = 'paymentTerminalId',
}

export const createMewsTerminalPaymentFormSchema = CommonProcessPaymentFormSchema.extend({
    [MewsTerminalFormField.PaymentTerminalId]: z.string(),
});

export type MewsTerminalPaymentFormValues = z.infer<typeof createMewsTerminalPaymentFormSchema>;
